var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#85D1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 18.3125L21.6546 23.6707C22.2745 24.1046 22.5844 24.3216 22.9215 24.4056C23.2193 24.4798 23.5307 24.4798 23.8285 24.4056C24.1656 24.3216 24.4755 24.1046 25.0954 23.6707L32.75 18.3125M18.5 30.5H28.25C29.8251 30.5 30.6127 30.5 31.2143 30.1935C31.7436 29.9238 32.1738 29.4936 32.4435 28.9643C32.75 28.3627 32.75 27.5751 32.75 26V20C32.75 18.4249 32.75 17.6373 32.4435 17.0357C32.1738 16.5064 31.7436 16.0762 31.2143 15.8065C30.6127 15.5 29.8251 15.5 28.25 15.5H18.5C16.9249 15.5 16.1373 15.5 15.5357 15.8065C15.0064 16.0762 14.5762 16.5064 14.3065 17.0357C14 17.6373 14 18.4249 14 20V26C14 27.5751 14 28.3627 14.3065 28.9643C14.5762 29.4936 15.0064 29.9238 15.5357 30.1935C16.1373 30.5 16.9249 30.5 18.5 30.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveContact);
export default __webpack_public_path__ + "static/media/active-contact.24acfd41437b4273afcab838df0bd6cc.svg";
export { ForwardRef as ReactComponent };